import { render, staticRenderFns } from "./DangerousGoods.vue?vue&type=template&id=bfc46512&scoped=true"
import script from "./DangerousGoods.vue?vue&type=script&lang=js"
export * from "./DangerousGoods.vue?vue&type=script&lang=js"
import style0 from "./DangerousGoods.vue?vue&type=style&index=0&id=bfc46512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc46512",
  null
  
)

export default component.exports